import { apiSlice } from "./apiSlice";

export const projectApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createProject: builder.mutation({
      query: (projectData) => ({
        url: "/projects/createProject",
        method: "POST",
        body: projectData,
      }),
      invalidatesTags: ["Project"],
    }),

    deleteProject: builder.mutation({
      query: (id) => ({
        url: `/projects/deleteProject/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Project"],
    }),

    updateProject: builder.mutation({
      query: ({ projectData, id }) => ({
        url: `/projects/updateProject/${id}`,
        method: "PATCH",
        body: projectData,
      }),
      invalidatesTags: ["Project"],
    }),

    getAllProjects: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/projects/getAllProjects?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Project"],
    }),

    getProjectById: builder.query({
      query: (id) => ({
        url: `/projects/getProjectById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateProjectMutation,
  useUpdateProjectMutation,
  useDeleteProjectMutation,
  useGetAllProjectsQuery,
  useGetProjectByIdQuery,
} = projectApi;
